export class PatientEmergencyContactInfo {
  id: number;
  patientId: number;
  emergencyContactName: string | null;
  relationship: string;
  contactNumber: string;
  consentToShareMedicalInfo: boolean | null;
  active: boolean;
}
